import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ProductMembershipList from '../component/fpg/list/ProductMembershipList'
import FilterActiveIcon from '../icons/filteractiveicon'
import FilterIcon from '../icons/filtericon'
import PlusIcon from '../icons/plusicon'
import MainLayout from '../mainLayout'
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
let sub;
export default class Productcouponlist extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            getLastUpdated: '',
            loaderFlag: false,
            data:[
                {
                    "label":"MEMBERSHIP LIST",
                    "Content":"This is content for Tab 1",
                }
            ]
        }
        this.apiserve = new service();
    }

    componentDidMount() {
        this.getProductLastUpdate();
        this.getLastUpdatedTimeandDate();
         this.setState({
           loaderFlag: true,
         });
       }
    
       getProductLastUpdate = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch(response.event){
                case 'ticketCms|membership|getLastUpdated':
                    this.setState({
                        getLastUpdated : response.data
                    })
                    break;
            }
        })
    }

    getLastUpdatedTimeandDate = () => {
        this.apiserve.sendevent("ticketCms|membership|getLastUpdated", { type: 1 });
    }
    render() {
        const { getLastUpdated } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment.tz(updateAt, "US/Mountain").format("h");
        var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
        var state = moment.tz(updateAt,"US/Mountain").format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list,index) => {
                                return(
                                    <li className="active" >
                                        <p className="uppercase text_left">
                                         <div>{list.label}</div>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                   
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} -{" "}
                        {moment.tz(updateAt,"US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
                        {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div>
                    <div className="table_wrap product_list_tbl film_list_table striped_table">
                        <ProductMembershipList history={this.props.history}/>
                    </div>                               
                </div>
        </React.Fragment>  
        )
    }
}
